import { createSlice } from "@reduxjs/toolkit";
import { IAppState } from "./app.model";
import { RootState } from "Features/store";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const initialState: IAppState = {
  appTheme: "light",
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    toggleAppTheme: (state) => {
      state.appTheme = state.appTheme === "light" ? "dark" : "light";
    },
  },
});

export const getCurrentAppTheme = (state: RootState) => state.app.appTheme;

// Action creators are generated for each case reducer function
export const { toggleAppTheme } = appSlice.actions;

const userPersistConfig = {
  key: "app",
  storage,
  whitelist: ["appTheme"],
};

export default persistReducer(userPersistConfig, appSlice.reducer);
